import { FieldBase } from '@/components/form';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useValidateKontaktEmail } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useValidateKontaktEmail/useValidateKontaktEmail';
import { Input } from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function EmailField() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { validate } = useValidateKontaktEmail();

  return (
    <form.AppField
      name="person.kontakt.email"
      validators={{
        onBlurAsync: async ({ value, fieldApi }) => {
          if (fieldApi.state.meta.errors) return;
          return await validate({ email: value });
        },
      }}>
      {(field) => {
        const isInvalid = !field.state.meta.isValid;
        return (
          <FieldBase
            label={t(
              'domain.mitarbeiter.create.steps.person.kontakt.form.email.label',
            )}
            infoText={t(
              'domain.mitarbeiter.create.steps.person.kontakt.form.email.info',
            )}>
            <Input
              id={field.name}
              name={field.name}
              value={field.state.value || ''}
              onChange={(e) =>
                field.handleChange(
                  e.target.value === '' ? null : e.target.value,
                )
              }
              onBlur={() => {
                field.setValue(field.state.value?.trim() || null);
                field.handleBlur();
              }}
              aria-invalid={isInvalid}
            />
          </FieldBase>
        );
      }}
    </form.AppField>
  );
}
